import React, { Component } from 'react'
import VideoUploader from './Uploader'
import { message } from 'hljd'
import styles from './style.module.less'
import { observer, inject } from 'mobx-react'

@inject('stepTwoStore')
@observer
export default class extends Component {
  state = {
    modal_visible: false
  }

  onUploadClick = e => {
    this.setState({
      modal_visible: true
    })
  }

  volidate = (up, file, res) => {
    let duration = res.avinfo.format.duration
    if (+duration > 300) {
      message.error('视频最长不可超过5分钟')
      return false
    }
    return true
  }

  onDelete = () => {
    this.props.stepTwoStore.onValueChange('video')({})
  }

  onError = (up, err) => {
    if (err.code === plupload.FILE_SIZE_ERROR) {
      message.error('视频尺寸超过限制')
    }
  }

  onVideoOk = e => {
    const result = {
      link: e.path,
      type: 'video',
      text: '',
      persistent_id: e.persistent_id,
      cover_path: e.cover_path,
      width: e.width,
      height: e.height
    }

    const { onValueChange } = this.props.store
    onValueChange && onValueChange('video')(result)

    this.setState({
      modal_visible: false
    })
  }

  onVideoCancel = () => {
    this.setState({
      modal_visible: false
    })
  }

  formatLink = video => {
    if (video.persistent_path && video.persistent_path.iphone) {
      return video.persistent_path.iphone
    } else {
      return video.link
    }
  }

  render() {
    const { modal_visible } = this.state
    const { video = {} } = this.props.stepTwoStore

    return (
      <div>
        {!video || !video.link ? (
          <div
            //ref="videobtn"
            onClick={this.onUploadClick}
            className={styles.upbut}
            // style={{ width: 240 }}
          >
            <span className={styles.upload_mark}>+</span>
            <span className={styles.discription}>上传视频</span>
          </div>
        ) : (
          <div className={styles.videoWrapper}>
            <video
              controls
              src={this.formatLink(video)}
              // style={{ height: 150 }}
              className={styles.upimg}
              poster={video.cover_path}
            />
            <span className={styles.delete} onClick={this.onDelete}>
              删除
            </span>
          </div>
        )}
        <VideoUploader
          modal_visible={modal_visible}
          onVideoOk={this.onVideoOk} // 模态框点击确定后的回调
          onVideoCancel={this.onVideoCancel} // 模态框点击取消后的回调
          // video={video}  // 视频  {cover_path: null, media_id: null, path: null, kind: 'video'}
          uploadOptions={{
            upload_url: 'https://up.qiniup.com', // 上传路径
            image_uptoken_url:
              '/p/wedding/home/APIUtils/image_upload_token?from=MerchandiseItemExample', // 获取图片token的url
            video_uptoken_url:
              '/p/wedding/home/APIUtils/video_upload_token?from=MerchandiseItemWork', // 获取上传视频token的url
            domain_url: 'https://qnm.hunliji.com/' // 图片显示前缀路径
          }}
          hide_outside_cover={true} // 是否显示外部封面，默认为true
          // node_ref={ref} // 打开上传模态框的ref，在hide_out_cover=false时使用
          max="500mb" //上传视频的大小限制，默认500mb,
          volidate={this.volidate}
          onError={this.onError}
        />
      </div>
    )
  }
}
